import {Component, Output, EventEmitter, ElementRef, HostListener, Input} from '@angular/core';

@Component({
    selector: 'action-button',
    templateUrl: './action-button.component.html',
    styleUrls: ['./action-button.component.scss']
})
export class ActionButtonComponent {
    @Input() data;
    @Output('onClick') clickOutput = new EventEmitter();

    public isShow: boolean = false;

    constructor(private elementRef: ElementRef) {}

    public toggle(): void {
        this.isShow = !this.isShow;
    }

    @HostListener('document:click', ['$event.target'])
    private hide(targetElement: HTMLElement): void {
        if (!this.elementRef.nativeElement.contains(targetElement)) {
            this.isShow = false;
        }
    }

    public onClick(type, data?): void {
        this.clickOutput.emit({type, data});
    }

}



// WEBPACK FOOTER //
// /app/src/app/views/admin/management-company/company-view/action-button/action-button.component.ts